import React from 'react';

import { useTranslation } from 'react-i18next';

import { useSwireApp } from 'react-hooks';

import { WhiteLabelType } from 'lane-shared/types/WhiteLabelType';

import { H4 } from 'components/typography';

import { ProfileForm } from './ProfileForm';
import { ProfileData } from 'lane-shared/contexts/OnboardingContext';

import styles from './index.scss';

const TRANSLATION_KEYS = {
  header: 'web.onboarding.userProfile.header',
  swireHeader: 'web.onboarding.userProfile.swire.header',
};

type Props = {
  defaultUserName?: string;
  defaultFirstName?: string;
  defaultLastName?: string;
  defaultPhone?: string;
  verifiedPhone?: string;
  defaultLocation?: string;
  onContinue: (data: ProfileData) => void;
  whitelabel: Pick<
    WhiteLabelType,
    | 'termsAndConditionsUrls'
    | 'privacyPolicyUrls'
    | 'complianceContact'
    | 'name'
    | 'settings'
    | 'url'
  >;
};

export const OnboardingProfile = ({
  defaultUserName,
  defaultFirstName,
  defaultLastName,
  defaultPhone,
  verifiedPhone,
  defaultLocation,
  onContinue,
  whitelabel,
}: Props) => {
  const { t } = useTranslation();
  const { isSwire: isSwireDomain } = useSwireApp(whitelabel);
  const handleSubmit = (data: ProfileData) => {
    onContinue(data);
  };

  return (
    <div className={styles.container}>
      <H4 className={styles.header} mb={6}>
        {isSwireDomain ? t(TRANSLATION_KEYS.swireHeader) : t(TRANSLATION_KEYS.header)}
      </H4>
      <ProfileForm
        defaultUserName={defaultUserName}
        defaultFirstName={defaultFirstName}
        defaultLastName={defaultLastName}
        defaultPhone={defaultPhone}
        verifiedPhone={verifiedPhone}
        defaultLocation={defaultLocation}
        onSubmit={handleSubmit}
        whitelabel={whitelabel}
      />
    </div>
  );
};
